"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportTemplateModal = void 0;
const react_1 = __importDefault(require("react"));
const drop_zone_1 = __importDefault(require("../drop_zone"));
const react_redux_1 = require("react-redux");
const routes_1 = require("../../../../../../constants/routes");
const doshx_controls_web_1 = require("doshx_controls_web");
const update_document_from_file_thunk_1 = require("../../../../../../reducers/slices/document/thunks/update/update_document_from_file_thunk");
const react_router_dom_1 = require("react-router-dom");
function ImportTemplateModal() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { selectedDocument } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const saveDocumentFromFile = (file) => {
        const payload = {
            file: file,
            pages: 1,
            status: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status,
            type: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.type,
            name: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.name,
            only_signer: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.only_signer,
            _id: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument._id,
        };
        dispatch((0, update_document_from_file_thunk_1.update_document_from_file_thunk)({
            data: payload,
            callback: (data) => {
                navigate(`${routes_1.CONSOLE_ROUTE}${routes_1.DOCUMENT_ROUTE}/${data === null || data === void 0 ? void 0 : data._id}`);
            },
        }));
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Import PDF / DOCX" }),
        react_1.default.createElement(drop_zone_1.default, { label: react_1.default.createElement("span", { className: "font-semibold" }, "Drag & drop a PDF or DOCX file here, or click to select"), types: "PDF, DOCX", accept: ".pdf, .docx", onChange: saveDocumentFromFile })));
}
exports.ImportTemplateModal = ImportTemplateModal;
